import {
    createNamedRepository,
    type NamedRepository,
} from './repositories/named';
import type { App, InjectionKey } from 'vue';
import {
    type NamedRepositoryOptions,
    repositoryInjectionKey,
} from './repositories';

export interface PluginOptions extends NamedRepositoryOptions {
    injectionKey?: string | symbol | InjectionKey<NamedRepository>;
}

export function partialsPlugin(app: App, options?: PluginOptions) {
    app.provide(
        options?.injectionKey ?? repositoryInjectionKey,
        createNamedRepository(options)
    );
}
